export default __webpack_public_path__ + "static/media/team-3.194ec994.png";